import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import BlogTilesComponent from "./component";

const BlogPostTiles = () => {
  const data = useStaticQuery(blogPostQuery);
  return <BlogTilesComponent {...data} />;
};

const blogPostQuery = graphql`
  query BlogPostQuery {
    allStoryComposition(
      filter: { uri: { glob: "**/blog/**", ne: "blog" } }
      sort: { timestamp: DESC }
    ) {
      edges {
        node {
          id
          shortDescription
          searchImage {
            childImageSharp {
              gatsbyImageData
            }
          }
          title
          uri
          timestamp
          devOnly
        }
      }
    }
    blogPostTiles {
      props {
        blogTileSubtitle
        blogTileTitle
      }
    }
  }
`;

export default BlogPostTiles;
